import React from 'react';

import { PinFilledIcon } from '@vlabs/icons';
import { Control, Tooltip } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import st from './PersonCardPin.module.sass';

function PersonCardPin(): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div
      className={st.Pin}
      data-testid="personCard.pin"
    >
      <Tooltip
        position="bottom"
        tooltipContent={t('shared:personCard.card_photo')}
      >
        <Control.IconButton
          className={st.Pin_icon}
          disabled
          icon={<PinFilledIcon />}
          size="small"
          variant="dimmed"
        />
      </Tooltip>
    </div>
  );
}

export { PersonCardPin };
